import '@babel/polyfill'

export default () => {
  const insightsDropdownHead = document.querySelector('.c-insightsMobileNav__head')
  if (insightsDropdownHead) {
    insightsDropdownHead.addEventListener('click', () => {
      insightsDropdownHead.parentElement.classList.toggle('-active')
    })
  }
}
